<template>
    <div>
      <h1>Petty Cash Services</h1>
      <p>Welcome to the Petty Cash Services page. Here you can manage your petty cash transactions.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PettyCashServicesIndex',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>